import React, { useState, useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import Notification_Offcanvas from "../../common_components/common_offcanvas/notification_offcanvas/Notification_Offcanvas";

const Sidebar_List = (props) => {
  const location = useLocation();
  const [activeKey, setActiveKey] = useState(null);

  const routes = [
    { key: "0", path: "/my-account", label: "My Account" },
    { key: "1", path: "/deposit", label: "Deposit" },
    { key: "2", path: "/withdrawal", label: "Withdrawal" },
    { key: "3", path: "/transaction-history", label: "Transaction History" },
    { key: "4", path: "/market-news", label: "Account Notice" },
    { key: "5", path: "/performance", label: "Performance" },
    { key: "6", path: "/settings", label: "Settings" },
    { key: "7", path: "/refer-and-earn", label: "Refer & Earn" },
  ];

  useEffect(() => {
    const current = routes.find((route) => route.path === location.pathname);

    if (current) {
      setActiveKey(current.key);
    } else {
      setActiveKey(null);
    }
  }, [location.pathname]);

  return (
    <div className="sidebar_list">
      <Accordion
        activeKey={activeKey}
        onSelect={(key) => {
          setActiveKey(key);
          props?.handleClose();
        }}
        flush
      >
        {routes.map((route) => (
          <>
            <Accordion.Item eventKey={route.key} key={route.key}>
              <Link
                to={route.path}
                className={`accordion-link ${
                  location.pathname === route.path ? "active" : ""
                }`}
              >
                <Accordion.Header>{route.label}</Accordion.Header>
              </Link>
            </Accordion.Item>
          </>
        ))}

        <Accordion.Item
          className="notification_item"
          onClick={() => props?.notificationAction()}
        >
          <Link>
            <Accordion.Header>Notification</Accordion.Header>
          </Link>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default Sidebar_List;
